import { Injectable } from '@angular/core';
import { PublicBoxSortType } from '../enums/public-box-sort-type';
import { SelectItem } from '@web/shared/ui';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicBoxSortTypeSelectItemsProviderService {
  private readonly entries = new Map<PublicBoxSortType, string>([
    [PublicBoxSortType.NameAscending, 'Nazwa rosnąco'],
    [PublicBoxSortType.NameDescending, 'Nazwa malejąco'],
    [PublicBoxSortType.PublishedAtAscending, 'Najstarsze'],
    [PublicBoxSortType.PublishedAtDescending, 'Najnowsze'],
  ]);

  public selectItems(): Observable<SelectItem<PublicBoxSortType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<PublicBoxSortType>(label, type),
      ),
    );
  }
}
